// import { useNavigate } from "react-router-dom";

import mainurl from "../config/mainurl.mjs";
import Bowser from "bowser";

const clientapifunc = async (CC, Uid) => {
  const browser =Bowser.parse(window.navigator.userAgent);
  // console.log(browser);
  var respVAl = {};
  await fetch(`${mainurl}/validatecc`, {
    method: "POST",
    headers: { "Content-Type": "application/json","Authorization":"Basic RERQSS1BRlNMLUxJVkUtVjE6YXdlciQlY3MzNDVkXnp4dHkyNkAjZmdocVNEKmFa"},
    body: JSON.stringify({ cc: CC, uid: Uid, ua:browser}),
  })
  .then((res) => res.json())
  .then((result) => Object.assign(respVAl, result)).catch(error=>{
    // console.log(error);
  })
  return respVAl;
};
export default clientapifunc;
